import {Component, Input, OnInit} from '@angular/core';
import {CentralizadaPoliticas} from '../../../../_models/gestor-politicas';
import {SelectItem} from 'primeng/api';
import {Estado} from '../../../../_models/estado';
import {ListaItem} from '../../../../_models/lista-item';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ListaService} from '../../../../_services/lista.service';
import {EstadoService} from '../../../../_services/estado.service';
import {NavService} from '../../../../_services/_nav.service';
import {AutenticacionService} from '../../../../_services/autenticacion.service';
import {forkJoin} from 'rxjs';
import {RequisitoRespaldoTipoVinculacion} from '../../../../_models/requisito-respaldo-tipo-vinculacion';
import {PoliticaDescarteVinculacion} from '../../../../_models/politica-descarte-vinculacion';
import {CodigosPoliticas} from '../../../../_enums/enum';

@Component({
  selector: 'app-politcas-formulario-descarte',
  templateUrl: './politcas-formulario-descarte.component.html',
  styleUrls: ['./politcas-formulario-descarte.component.css']
})
export class PolitcasFormularioDescarteComponent implements OnInit {

  @Input() politica: CentralizadaPoliticas;
  @Input() submitted: boolean;

  lisEstados: SelectItem[] = [];
  listaEstados: Estado[] = [];

  lisCausales: SelectItem[] = [];
  listaCausales: ListaItem[] = [];

  lisVinculaciones: SelectItem[] = [];
  lisTodasVinculaciones: ListaItem[] = [];
  formulario: FormGroup;
  carInformacionInicial = true;



  constructor( private fb: FormBuilder,
               private lisServicio: ListaService,
               private estServicio: EstadoService,
               private navServicio: NavService,
               private autServicio: AutenticacionService,) { }

  ngOnInit() {
    forkJoin(
      this.estServicio.listadoHabilitados(),
      this.lisServicio.getMasterDetails( 'ListasCausalesSolicitudes' )
    ).subscribe( ([estados,  vinculacion]) => {

      this.listaEstados = estados;
      estados.map( ( s: Estado ) => {
        this.lisEstados.push( { label: s.nombre, value: s.idEstado } );
      } );

      this.listaCausales = vinculacion;
      vinculacion.map( ( s: ListaItem ) => {
        this.lisCausales.push( { label: s.nombre, value: s.idLista } );
      } );

      this.politica.listaVinculaciones.map( ( s: ListaItem ) => {
        this.lisVinculaciones.push( { label: s.nombre, value: s.idLista } );
      } );
      this.cargarFormulario();
    });
  }

  cargarFormulario() {

    const vinculacion = [];
    if(this.politica.descartesVinculaciones.length > 0) {
      this.politica.descartesVinculaciones.forEach( e => {
        if ( e.indicadorHabilitado ) {
          vinculacion.push( e.idVinculacion );
        }
      } );
    }
    this.formulario = this.fb.group( {
      indicadorDescarta: [ this.politica.politica.indicadorDescarta ? this.politica.politica.indicadorDescarta: false ],
      idEstado: [ this.politica.politica.idEstado ? this.politica.politica.idEstado : null],
      idCausal: [ this.politica.politica.idCausal ],
      idVinculacion: [ vinculacion ]
    } );
    this.carInformacionInicial = false;
  }

  get f() {
    return this.formulario.controls;
  }


  validarDescarte() {

    const proDestinoCrear = this.formulario.value;
    let cont = 0;

    if(this.f.idEstado.value){
      this.politica.politica.idEstado = this.f.idEstado.value;
      cont = 1;
    }

    if(this.f.idCausal.value){
      this.politica.politica.idCausal = this.f.idCausal.value;
      cont++;
    }


    if(proDestinoCrear.idVinculacion){
      const tempTipoVinculacion: PoliticaDescarteVinculacion[] = [];
      proDestinoCrear.idVinculacion.map( sud => {
        let temp = {} as PoliticaDescarteVinculacion;
        const d = this.lisTodasVinculaciones.find( x => x.idLista === sud );
        temp.idVinculacion = sud;
        temp.idPolitica = this.politica.politica.idPolitica;
        temp.indicadorHabilitado = true;
        if (d) {
          temp.vinculacion = d.nombre;
        }
        const existe = this.politica.descartesVinculaciones.find( x => x.idVinculacion === temp.idVinculacion);
        if(existe) {
          temp.idPoliticaDescarteVinculacion = existe.idPoliticaDescarteVinculacion;
        }
        tempTipoVinculacion.push(temp);
      });
      this.politica.descartesVinculaciones.forEach( e => {
        if ( e.idPoliticaDescarteVinculacion &&  e.indicadorHabilitado && !proDestinoCrear.idVinculacion.find( y => y === e.idVinculacion ) ) {
          e.indicadorHabilitado = false;
          tempTipoVinculacion.push( e );
        }
      } );
      this.politica.descartesVinculaciones = [];
      this.politica.descartesVinculaciones = tempTipoVinculacion;
      cont++;
    }

    if (this.politica.politica) {
      const d = this.politica.listaCategoriasPoliticas.find( x => x.idLista === this.politica.politica.idCategoriaPolitica );
      if (d && d.codigo === CodigosPoliticas.PoliticaPreselecta && cont === 4 ) {
        this.politica.descartes = true;
      } else if (cont === 3){
        this.politica.descartes = true;
      } else {
        this.politica.descartes = false;
      }
    }
  }


}
